<template>
  <div id="home">
    <div style="background-color: white; margin: 1rem 2rem">
      <div class="pos_container_panel">
        <!--search area-->
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="padding-top: 1rem"
          label-width="150px"
        >
          <el-row class="rowtop" style="padding-top: 2rem">
            <el-col :span="12">
              <el-form-item
                label="客户名称："
                style="margin-bottom: 0; margin-left: 1rem"
              >
                <el-input
                  @click="showClientNamePop"
                  readonly
                  v-model="searchForm.client"
                  placeholder="请选择"
                  style="margin-left: 0px"
                  class="myselect_inner myicon_inner"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <hr
            style="
              margin: 1rem -14rem 0rem;
              background-color: rgb(241 243 245);
              height: 0.2rem;
              border: none;
            "
          />
          <el-row class="rowtop" style="padding-top: 2rem">
            <el-col :span="24">
              <el-form-item
                label="弹出配置："
                class="rc-popup-config"
                style="margin-bottom: 0; margin-left: 1rem; width: 100%"
                prop="username"
              >
                <el-row>
                  <el-radio
                    @change="changeSelectType"
                    :disabled="isSelect"
                    v-model="dataForm.type"
                    label="1"
                    >自定义</el-radio
                  >
                  <el-select
                    :disabled="isSelect || isRCSelect"
                    v-model="dataForm.symbol"
                    filterable
                    style="width: 110px; margin-left: 1rem; margin-right: 5px"
                  >
                    <el-option label="大于" value="1"></el-option>
                    <el-option label="大于等于" value="2"></el-option>
                    <el-option label="小于" value="3"></el-option>
                    <el-option label="小于等于" value="4"></el-option>
                  </el-select>
                  <el-input
                    :disabled="isSelect || isRCSelect"
                    v-model="dataForm.price"
                    style="width: 95px; margin-right: 5px"
                  ></el-input>
                  <el-select
                    :disabled="isSelect || isRCSelect"
                    v-model="dataForm.currencyCode"
                    :placeholder="$t('MANUAL.SELECTPLACEHOLDER')"
                    filterable
                    style="width: 100px"
                  >
                    <el-option
                      v-for="item in this.getcurrencySignData"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-row>
                <el-row>
                  <el-radio
                    @change="changeSelectType"
                    :disabled="isSelect"
                    v-model="dataForm.type"
                    label="2"
                    >按差规弹出</el-radio
                  >
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <hr
            style="
              margin: 1rem -14rem 0rem;
              background-color: rgb(241 243 245);
              height: 0.2rem;
              border: none;
            "
          />
          <el-row class="rowtop" style="padding-top: 2rem">
            <el-col :span="24">
              <el-form-item
                :label="RCText + (key + 1)"
                v-for="(item, key) in this.RCListText"
                :key="key"
                class="formItem"
              >
                <el-input
                  v-model="item.code"
                  placeholder="请输入Code"
                  :disabled="isSelect"
                  style="width: 80px; margin-right: 10px"
                ></el-input>
                <el-input
                  v-model="item.cnText"
                  placeholder="请输入中文内容"
                  :disabled="isSelect"
                  style="width: 230px; margin-right: 10px"
                  :title="item.cnText"
                ></el-input>
                <el-input
                  v-model="item.enText"
                  placeholder="请输入英文内容"
                  :disabled="isSelect"
                  style="width: 230px; margin-right: 10px"
                  :title="item.enText"
                ></el-input>
                <el-switch v-model="item.flag"></el-switch>
              </el-form-item>
              <el-form-item
                label=""
                class="formItem"
                style="padding-left: 100px"
              >
                <el-button
                  @click="addRCList"
                  type="warning"
                  :disabled="isSelect"
                  >添加RC规则</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
          <hr
            style="
              margin: 1rem -14rem 0rem;
              background-color: rgb(241 243 245);
              height: 0.2rem;
              border: none;
            "
          />
          <el-row class="rowtop" style="padding-top: 2rem">
            <el-col :span="24">
              <div class="rc-compliance-row">
                <el-form-item label="合规" class="rc-compliance-item">
                  <el-select
                    v-model="dataForm.compliance"
                    multiple
                    placeholder="请选择合规RC"
                    @change="complianceChange"
                    :disabled="isSelect"
                  >
                    <el-option
                      v-for="item in getCompliance"
                      :key="item.code"
                      :label="item.code"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="rc-compliance-row">
                <el-form-item label="不合规" class="rc-compliance-item">
                  <el-select
                    v-model="dataForm.nocompliance"
                    multiple
                    placeholder="请选择不合规RC"
                    @change="noComplianceChange"
                    :disabled="isSelect"
                  >
                    <el-option
                      v-for="item in getCompliance"
                      :key="item.code"
                      :label="item.code"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否在详情页展示" class="rc-detail-display-item">
                  <el-checkbox v-model="dataForm.isShow" :disabled="isSelect">是</el-checkbox>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row
            v-show="!isSelect"
            class="rowtop"
            style="padding-top: 2rem; text-align: right; margin-right: 100px"
          >
            <el-col :span="24" style="float: right">
              <el-form-item label="" class="formItem">
                <el-button @click="saveRC" type="warning">保存</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
  </div>
</template>

<script>
import {posRCSearch, posRCSsave } from "@/api/platformData";
import { currencySign } from "@/config/currency";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import ClientList from "@/components/ClientList.vue";
export default {
  name: "HBERC.vue",
  components: {
    ConfirmBoxs,
    ClientList,
  },
  data() {
    return {
      clientListFlag: false,
      hotelCustomerCode: "",
      searchForm: {
        client: "",
      },
      isSelect: true,
      isRCSelect: false,
      dataForm: {
        id: 0,
        type: "1",
        price: 0,
        currencyCode: "CNY",
        text: "",
        posid: 0,
        symbol: "2",
        compliance: [],
        nocompliance: [],
        isShow: false,
      },
      RCText: "RC",
      RCList: [],
      RCListText: [{ code: "", cnText: "", enText: "", flag: true }],
      confirmFlag: false,
      confirmMsg: "",
      confirmIcon: "",
      PriceRule: {
        // username: [{
        //   required: true,
        //   message: '请输入用户名',
        //   trigger: 'blur'
        // },
        // {
        //   min: 3,
        //   max: 10,
        //   message: '用户名长度在3-10个字符之间',
        //   trigger: 'blur'
        // }
        // ]
      },
    };
  },
  computed: {
    getcurrencySignData() {
      var keys = Object.keys(currencySign);
      return keys;
    },
    getCompliance() {
      let arr = [];
      let arr_Code = [];
      for (let i = 0; i < this.RCListText.length; i++) {
        if (
          this.RCListText[i].cnText != "" &&
          this.RCListText[i].enText != "" &&
          this.RCListText[i].code != "" &&
          this.RCListText[i].flag
        ) {
          if (arr_Code.indexOf(this.RCListText[i].code) < 0) {
            arr.push({ code: this.RCListText[i].code });
            arr_Code.push(this.RCListText[i].code);
          }
        }
      }
      return arr;
    },
  },
  mounted() {},
  methods: {
    closeaddDialog(formRule) {
      this.$refs[formRule].resetFields();
    },
    closeDialog(form) {
      // console.log(form);
      // this.$refs[form].resetFields();
      form.searchClient = "";
      form.searchClientNo = "";
    },
    // 弹出客户姓名窗口方法
    showClientNamePop() {
      this.clientListFlag = true;
    },
    //选择客户
    selectClient(item) {
      this.hotelCustomerCode = item.customerCode;
      this.searchForm.client = item.customerName;
      this.searchRusult();
      this.isSelect = false;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    async searchRusult() {
      let customerParam = {
        params: {
          posCode: this.hotelCustomerCode,
        },
      };
      let that = this;
      await posRCSearch(customerParam)
        .then((res) => {
          if (res.code == 200) {
            let compliance = "";
            let nocompliance = "";
            let item = res.data.posReasonCodeAddUpdateReq;
            if (item.id > 0) {
              that.dataForm.id = item.id;
              that.dataForm.type = item.type.toString();
              that.dataForm.posid = item.posid;

              that.dataForm.text = item.text;
              that.dataForm.price = item.price;
              that.dataForm.currencyCode = item.currencyCode;

              that.dataForm.text = item.text;

              compliance = item.compliance;
              nocompliance = item.noCompliance;

              that.dataForm.isShow = item.isShow;
            } else {
              //无初始数据默认赋值
              that.dataForm.id = item.id;
              that.dataForm.posid = item.posid;

              that.dataForm.type = "1";
              that.dataForm.price = 0;
              that.dataForm.currencyCode = "CNY";
              that.dataForm.text = "";

              that.dataForm.compliance = [];
              that.dataForm.nocompliance = [];
              that.dataForm.isShow = false;
            }

            if (that.dataForm.type == "1") {
              that.isRCSelect = false;
            } else {
              that.isRCSelect = true;
            }

            if (that.dataForm.text == "") {
              that.RCListText = [
                { code: "", cnText: "", enText: "", flag: true },
              ];
            } else {
              that.RCListText = [];
              let textAyy = that.dataForm.text.split(",");
              let freezeArr=[];
              for (var i = 0; i < textAyy.length; i++) {
                let str = textAyy[i].split("-");
                let item={
                  code: str[0],
                  cnText: str[1],
                  enText: str[2],
                  flag: str[3] == undefined ? true : JSON.parse(str[3]),
                };
                if(item.flag)
                {
                  that.RCListText.push(item);
                }
                else
                {
                  freezeArr.push(item);
                }
              }
              that.RCListText.push.apply(that.RCListText,freezeArr);
            }
            if (compliance != "" && compliance != undefined) {
              that.dataForm.compliance = compliance.toString().split(",");
            }
            if (nocompliance != "" && nocompliance != undefined) {
              that.dataForm.nocompliance = nocompliance.toString().split(",");
            }
          } else {
            that.confirmFlag = true;
            that.confirmMsg = "获取失败,请重新选择客户";
            return;
          }
        })
        .catch(function (error) {
          console.log("POS 请求失败", error);
        });
    },

    //confirm
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    changeSelectType() {
      this.isRCSelect = this.dataForm.type !== "1";
    },
    addRCList() {
      if (this.RCListText.length >= 10) {
        this.confirmFlag = true;
        this.confirmMsg = "最多添加10条";
        return;
      }
      this.RCListText.push({ code: "", cnText: "", enText: "", flag: true });
    },
    //保存信息
    async saveRC() {
      this.RCList = [];
      let arr_Code = [];
      let price = this.dataForm.price;
      let flag = 0;
      console.log(this.dataForm.type);
      var reg = /^[0-9]+.?[0-9]*$/;
      if (!this.isSelect && !this.isRCSelect && !reg.test(price)) {
        this.confirmFlag = true;
        this.confirmMsg = "价格只能输入整数";
        return;
      }
      for (var i = 0; i < this.RCListText.length; i++) {
        if (
          (this.RCListText[i].cnText == "" ||
            this.RCListText[i].cnText == undefined) &&
          this.RCListText[i].enText != "" &&
          this.RCListText[i].enText != undefined
        ) {
          this.confirmFlag = true;
          this.confirmMsg = "中英文RC规则需一并填写";
          return;
        }
        if (
          this.RCListText[i].cnText != "" &&
          this.RCListText[i].cnText != undefined &&
          (this.RCListText[i].enText == "" ||
            this.RCListText[i].enText == undefined)
        ) {
          this.confirmFlag = true;
          this.confirmMsg = "中英文RC规则需一并填写";
          return;
        }
        if (
          this.RCListText[i].cnText != "" &&
          this.RCListText[i].cnText != undefined &&
          (this.RCListText[i].code == "" ||
            this.RCListText[i].code == undefined)
        ) {
          this.confirmFlag = true;
          this.confirmMsg = "请填写code";
          return;
        }
        if (
          this.RCListText[i].enText != "" &&
          this.RCListText[i].enText != undefined &&
          (this.RCListText[i].code == "" ||
            this.RCListText[i].code == undefined)
        ) {
          this.confirmFlag = true;
          this.confirmMsg = "请填写code";
          return;
        }
        if (
          this.RCListText[i].code != "" &&
          this.RCListText[i].code != undefined &&
          (this.RCListText[i].enText == "" ||
            this.RCListText[i].enText == undefined ||
            this.RCListText[i].cnText == "" ||
            this.RCListText[i].cnText == undefined)
        ) {
          this.confirmFlag = true;
          this.confirmMsg = "请填写RC规则";
          return;
        }
        if (
          this.RCListText[i].code != "" &&
          this.RCListText[i].code != undefined &&
          this.RCListText[i].cnText != "" &&
          this.RCListText[i].enText != "" &&
          this.RCListText[i].cnText != undefined &&
          this.RCListText[i].enText != undefined
        ) {
          if (arr_Code.length > 0) {
            if (arr_Code.indexOf(this.RCListText[i].code) >= 0) {
              this.confirmFlag = true;
              this.confirmMsg = "Code重复,请重新填写";
              return;
            }
          }
          this.RCList.push(
            this.RCListText[i].code +
              "-" +
              this.RCListText[i].cnText +
              "-" +
              this.RCListText[i].enText +
              "-" +
              this.RCListText[i].flag
          );
          arr_Code.push(this.RCListText[i].code);
          flag++;
          if (flag != i + 1) {
            this.confirmFlag = true;
            this.confirmMsg = "请按照顺序填写RC规则";
            return;
          }
        }
        // if (this.RCList.length == 0) {
        //   this.confirmFlag = true;
        //   this.confirmMsg = "请填写RC规则信息";
        //   return;
        // }

        // if (this.dataForm.compliance.length == 0) {
        //   this.confirmFlag = true;
        //   this.confirmMsg = "请选择合规RC";
        //   return;
        // }
        // if (this.dataForm.nocompliance.length == 0) {
        //   this.confirmFlag = true;
        //   this.confirmMsg = "请选择不合规RC";
        //   return;
        // }
      }
      //判断RC配置是否重复
      let intersection = [];
      if (this.dataForm.compliance.length > 0) {
        let _arrSet = new Set(this.dataForm.compliance);
        intersection = this.dataForm.nocompliance.filter((item) =>
          _arrSet.has(item)
        );
        if (intersection.length > 0) {
          this.confirmFlag = true;
          this.confirmMsg = "RC配置重复,请重新选择";
          return;
        }
      }
      let flagCode=[];
      this.getCompliance.forEach(e => { 
        flagCode.push(e.code)
      })
      //判断合规code是否存在
      const oldIds = this.RCListText.map((item) => item.code);
      if (this.dataForm.compliance.length > 0) {
        let result = this.dataForm.compliance.filter(
          (item) => !oldIds.includes(item)
        );
        if (result.length > 0) {
          this.confirmFlag = true;
          this.confirmMsg = "合规RC配置内容不正确,请重新选择";
          return;
        }
        if(flagCode.length>0)
        {
          result = this.dataForm.compliance.filter(
            (item) => !flagCode.includes(item)
          );
          if (result.length > 0) {
            this.confirmFlag = true;
            this.confirmMsg = "合规RC配置内容不正确,请重新选择";
            return;
          }
        }
        else
        {
          this.confirmFlag = true;
          this.confirmMsg = "合规RC配置内容不正确,请重新选择";
          return;
        }
      }

      //判断不合规code是否存在
      if (this.dataForm.nocompliance.length > 0) {
        let result = this.dataForm.nocompliance.filter(
          (item) => !oldIds.includes(item)
        );
        if (result.length > 0) {
          this.confirmFlag = true;
          this.confirmMsg = "不合规RC配置内容不正确,请重新选择";
          return;
        }
        if(flagCode.length>0)
        {
          result = this.dataForm.nocompliance.filter(
            (item) => !flagCode.includes(item)
          );
          if (result.length > 0) {
            this.confirmFlag = true;
            this.confirmMsg = "不合规RC配置内容不正确,请重新选择";
            return;
          }
        }
        else
        {
          this.confirmFlag = true;
          this.confirmMsg = "不合规RC配置内容不正确,请重新选择";
          return;
        }
      }
      if(flagCode.length>0)
      {
        let count=this.dataForm.nocompliance.length+this.dataForm.compliance.length;
        if(flagCode.length>count)
        {
          this.confirmFlag = true;
          this.confirmMsg = "还有启用的RC规则没有设置,请重新选择";
          return;
        }
      }
      this.dataForm.text = this.RCList.join(",");
      let Param = {
        id: this.dataForm.id,
        posCode: this.hotelCustomerCode,
        posid: this.dataForm.posid,
        price: this.dataForm.price,
        currencyCode: this.dataForm.currencyCode,
        type: this.dataForm.type,
        text: this.dataForm.text,
        compliance: this.dataForm.compliance.toString(),
        nocompliance: this.dataForm.nocompliance.toString(),
        isShow: this.dataForm.isShow,
        symbol: this.dataForm.symbol,
      };
      let that = this;
      await posRCSsave(Param)
        .then((res) => {
          if (res.code != 200) {
            that.confirmFlag = true;
            that.confirmMsg = "修改失败,请重试";
            return;
          } else {
            that.confirmFlag = true;
            that.confirmMsg = "保存成功";
            return;
          }
        })
        .catch(function (error) {
          console.log("POS 请求失败", error);
        });
    },
    clearRC() {
      if (this.dataForm.type != 3) {
        this.confirmFlag = true;
        this.confirmMsg = "弹出配置为禁用时才能使用清空功能";
        return;
      }
      this.RCListText = [{ code: "", cnText: "", enText: "", flag: true }];
      this.dataForm.compliance = [];
      this.dataForm.nocompliance = [];
      this.dataForm.isShow = false;
      this.dataForm.price = 0;
    },
    noComplianceChange(value) {
      let intersection = [];
      if (this.dataForm.compliance.length > 0) {
        let _arrSet = new Set(this.dataForm.compliance);
        intersection = value.filter((item) => _arrSet.has(item));
      }
      if (intersection.length > 0) {
        this.confirmFlag = true;
        this.confirmMsg = "配置重复,请重新选择";
        return;
      }
    },
    complianceChange(value) {
      let intersection = [];
      if (this.dataForm.nocompliance.length > 0) {
        let _arrSet = new Set(this.dataForm.nocompliance);
        intersection = value.filter((item) => _arrSet.has(item));
      }
      if (intersection.length > 0) {
        this.confirmFlag = true;
        this.confirmMsg = "配置重复,请重新选择";
        return;
      }
    },
  },
};
</script>

<style scoped>
.formItem {
  margin-left: 1rem;
  /* width: 30%; */
  margin-top: 15px;
  margin-bottom: 5px;
}

.rc-popup-config :deep(.el-form-item__content) {
  flex-direction: column;
  align-items: flex-start;
}

.rc-popup-config .el-row {
  width: 100%;
}

.rc-compliance-row {
  display: flex;
  align-items: flex-start;
  min-height: 40px;
  margin-left: 1rem;
}

.rc-compliance-item {
  width: 520px;
  margin-bottom: 10px;
}

.rc-compliance-item :deep(.el-form-item__content),
.rc-compliance-item :deep(.el-select) {
  width: 360px;
}

.rc-detail-display-item {
  margin: 0 0 10px 24px;
}

::v-deep .dialog-one .el-dialog__body {
  padding: 0px;
}
</style>
